<template>
  <!-- // 报表钻取明细 -->
  <div class="app-container">
    <div class="mycontainer">
      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="统计年份" prop="jcnf">
          <el-date-picker
            ref="jcnf"
            v-model="queryParams.jcnf"
            type="year"
            :clearable="false"
            value-format="yyyy"
            placeholder="选择年"
            size="small"
            style="width: 185px"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属部门" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="queryParams.bmbh"
            placeholder="所属部门"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            @change="handleChangeBm"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目状态" prop="xmzt">
          <el-select
            ref="xmzt"
            v-model="queryParams.xmzt"
            placeholder="项目状态"
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 185px"
            class="filter-item"
            @change="handleChangeHtzt"
          >
            <el-option
              v-for="item in htztList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="queryParams.xmbh"
            placeholder="项目名称"
            filterable
            size="small"
            style="width: 285px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            style="margin-right: 10px"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div class="jccs">
      <el-select
        ref="jccs"
        v-model="queryParams.jccs"
        id="jccsSelect"
        @change="handleChangeJccs"
        style="width: 350px"
      >
        <el-option
          v-for="item in xmOptions"
          :key="item.key"
          :label="item.key"
          :value="item.value"
        />
      </el-select>
      <el-date-picker
        v-model="queryParams.jcyf"
        type="month"
        placeholder="选择月"
        :clearable="false"
        id="jcyf"
        style="margin-left: 15px"
      >
      </el-date-picker>
    </div>
    <div>
      <div>
        <el-table
          v-loading="listLoading"
          :data="list"
          fit
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          :max-height="height"
          class="fzxsjList"
          id="fzxsjList"
        >
          <el-table-column
            label="序号"
            prop="xh"
            min-width="50px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="指标评价"
            prop="zbmc"
            min-width="150px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="评分说明"
            prop="pfsm"
            min-width="200px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="a"
            prop="qyzj"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.a }}
            </template>
          </el-table-column>
          <el-table-column
            label="b"
            prop="qyzj"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.b }}
            </template>
          </el-table-column>
          <el-table-column
            label="c"
            prop="qyzj"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.c }}
            </template>
          </el-table-column>
          <el-table-column
            label="评价结果"
            prop="jcjg"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <div class="fzj_pjjg">
                <el-select
                  ref="xmbh"
                  v-model="scope.row.jcjg"
                  size="small"
                  style="width: 80px"
                  class="filter-item"
                  @input="handleChangeJcjg(scope.row.jcjg, scope.$index)"
                  v-if="scope.row.zbid === 8"
                  placeholder=" "
                  :disabled="!canEdit"
                >
                  <el-option
                    v-for="item in pjjgList2"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                    :style="{
                      background:
                        item.dictValue === '高'
                          ? '#D9001B'
                          : item.dictValue === '中'
                          ? '#F59A23'
                          : '#70B603',
                      color: '#fff',
                      textAlign: 'center',
                    }"
                  />
                </el-select>
                <el-select
                  ref="xmbh"
                  v-model="scope.row.jcjg"
                  size="small"
                  style="width: 80px"
                  class="filter-item"
                  @input="handleChangeJcjg(scope.row.jcjg, scope.$index)"
                  v-else-if="scope.row.zbid === 7"
                  placeholder=" "
                  :disabled="!canEdit"
                  clearable
                >
                  <el-option
                    v-for="item in pjjgList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                    :style="{
                      background:
                        item.dictValue === 'A'
                          ? '#D9001B'
                          : item.dictValue === 'B'
                          ? '#F59A23'
                          : '#70B603',
                      color: '#fff',
                      textAlign: 'center',
                    }"
                  />
                </el-select>

                <el-select
                  ref="xmbh"
                  v-model="scope.row.jcjg"
                  size="small"
                  style="width: 80px"
                  class="filter-item"
                  @input="handleChangeJcjg(scope.row.jcjg, scope.$index)"
                  v-else
                  placeholder=" "
                  :disabled="!canEdit"
                >
                  <el-option
                    v-for="item in pjjgList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                    :style="{
                      background:
                        item.dictValue === 'A'
                          ? '#D9001B'
                          : item.dictValue === 'B'
                          ? '#F59A23'
                          : '#70B603',
                      color: '#fff',
                      textAlign: 'center',
                    }"
                  />
                </el-select>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="footer-btn" v-if="canEdit">
      <el-button type="primary" @click="handleSave">确定</el-button>
    </div>
  </div>
</template>
  
<script>
import { getDict, getXmxxList } from "@/api/common";
import { getBmxxList } from "@/api/itWeekly.js";
import {
  exportfzInspecList,
  getFzInspecList,
  updateFzInspec,
  xmCheckAuthor,
} from "@/api/xmcheck.js";
import Pagination from "@/components/Pagination";
import { addExportFileDate } from "@/utils/utils";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  // 列表分页
  name: "xsjmxList",
  components: { Pagination },
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          let oldDate = new Date("2023-12-31T12:00:00.000Z");
          let oneYear = new Date(oldDate).getTime();
          return time.getTime() < oneYear;
        },
      },
      height: 800,
      listLoading: false,
      list: [],
      queryParams: {
        jcnf: moment().format("YYYY"),
        bmbh: [],
        xmbh: "",
        xmmc: "",
        xmzt: [],
        jccs: "1",
        jcyf: "",
      },
      xmOptions: [],
      pjjgList: ["A", "B", "C"],
      pjjgList2: ["高", "中", "低"],
      bmList: [],
      htztList: [],
      xmList: [],
      canEdit: false,
      storageXmbh: "",
      storagejccs: "",
    };
  },
  mounted() {
    this.startWatching();
  },
  created() {
    if (!this.user.xm) {
      this.$store.dispatch("common/fetchUserInfoAction");
    }
    if (sessionStorage.getItem("fzCheckDetailParams")) {
      let initParams = JSON.parse(
        sessionStorage.getItem("fzCheckDetailParams")
      );
      this.queryParams = {
        ...this.queryParams,
        ...initParams,
      };
      this.queryParams.xmzt = [this.queryParams.xmzt + ""];
      this.queryParams.bmbh = [this.queryParams.bmbh];
      this.storageXmbh = this.queryParams.xmbh;
      this.storagejccs = this.queryParams.jccs;
    }
    getBmxxList("2", "1").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
        // this.queryParams.bmbh = [this.bmList[0].bmbh];
      }
    });
    getDict("xmgl_xmzt", "2").then((res) => {
      if (res.code == 0) {
        this.htztList = res.data;
        // if (localStorage.getItem("fzj_params")) {
        // } else {
        //   this.queryParams.xmzt = [res.data[0].dictValue];
        // }
        this.getXmxxListFun(true);
      }
    });
    getDict("xmInspection_fz_pjjg1", "1").then((res) => {
      if (res.code == 0) {
        this.pjjgList = res.data;
      }
    });
    getDict("xmInspection_fz_pjjg2", "1").then((res) => {
      if (res.code == 0) {
        this.pjjgList2 = res.data;
      }
    });
    this.getList();
  },
  methods: {
    getList() {
      const { xmbh, jcnf, jccs } = this.queryParams;
      const data = {
        xmbh,
        jcnf,
        jccs,
      };
      getFzInspecList(data).then((res) => {
        if (res.code === 0) {
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 160;
          this.list = res.data;
          for (let i in res.data) {
            setTimeout(() => {
              if (res.data[i].jcjg === "A" || res.data[i].jcjg === "高") {
                document.querySelectorAll(".fzj_pjjg input ")[
                  i
                ].style.backgroundColor = "rgb(217, 0, 27)";
              } else if (
                res.data[i].jcjg === "B" ||
                res.data[i].jcjg === "中"
              ) {
                document.querySelectorAll(".fzj_pjjg input ")[
                  i
                ].style.backgroundColor = "rgb(245, 154, 35)";
              } else {
                document.querySelectorAll(".fzj_pjjg input ")[
                  i
                ].style.backgroundColor = "rgb(112, 182, 3)";
              }
            }, 50);
          }
          this.queryParams.xmmc = res.data[0].xmjc;
          this.queryParams.jcyf = res.data[0].jcyf
            ? moment(res.data[0].jcyf)
            : "";

          this.setXmmc();
          this.getPermision();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getXmxxListFun(isFirst) {
      getXmxxList({
        xmlx: "DS",
        type: "2",
        range: "1",
        xmzt: this.queryParams.xmzt.join(","),
        bmbh: this.queryParams.bmbh.join(","),
      }).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
          if (!isFirst) {
            this.queryParams.xmbh = this.xmList[0].xmbh;
          }
          // this.queryParams.xmbh = this.xmList[0].xmbh;
          // this.queryParams.xmmc = this.xmList[0].xmjc;
          // this.getList();
        }
      });
    },
    setXmmc() {
      this.xmOptions = [
        {
          key: `${this.queryParams.xmmc}-首次`,
          value: "1",
        },
        {
          key: `${this.queryParams.xmmc}-二次`,
          value: "2",
        },
      ];
    },
    handleChangeBm(i) {
      this.queryParams.bmbh = i;
      this.getXmxxListFun();
    },
    handleChangeHtzt(i) {
      this.queryParams.xmzt = i;
      this.getXmxxListFun();
    },
    handleChangeJccs(i) {
      this.queryParams.jccs = i;
      this.getList();
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    handleSave() {
      let isHasValue = true; //是否全部已填写
      for (let i of this.list) {
        if (i.zbid == 7) {
          continue;
        }
        if (!i.jcjg) {
          isHasValue = false;
          break;
        }
      }
      if (!this.queryParams.jcyf) {
        this.$message.error("请选择检查月份！");
        return;
      }
      if (isHasValue) {
        if (this.list[7].jcjg) {
          const msg =
            this.list[7].jcjg === "低"
              ? "按项目计划执行即可！"
              : this.list[7].jcjg === "中"
              ? "制定整改计划，逐步改进！"
              : "制定整改计划，调配资源马上开展风险化解工作！";

          this.$confirm(msg, "提示", {
            confirmButtonText: "保存",
            cancelButtonText: "取消",
          })
            .then(() => {
              this.saveForm();
            })
            .catch(() => {});
        } else {
          this.saveForm();
        }
      } else {
        this.$message.error("请填写评价指标！");
      }
    },
    saveForm() {
      const tempList = [];
      for (let i in this.list) {
        tempList[i] = {
          xmbh: this.list[i].xmbh,
          zbid: this.list[i].zbid,
          jcnf: this.queryParams.jcnf,
          jccs: this.queryParams.jccs,
          jcjg: this.list[i].jcjg,
          type: this.list[i].lx,
          ygbh: this.user.ygbh,
          jcyf: moment(this.queryParams.jcyf).format("YYYYMM"),
        };
        this.list[i].id ? (tempList[i].id = this.list[i].id) : "";
      }
      updateFzInspec(tempList).then((res) => {
        if (res.code === 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleChangeJcjg(jcjg, i) {
      setTimeout(() => {
        if (jcjg === "A" || jcjg === "高") {
          document.querySelectorAll(".fzj_pjjg input ")[
            i
          ].style.backgroundColor = "rgb(217, 0, 27)";
        } else if (jcjg === "B" || jcjg === "中") {
          document.querySelectorAll(".fzj_pjjg input ")[
            i
          ].style.backgroundColor = "rgb(245, 154, 35)";
        } else {
          document.querySelectorAll(".fzj_pjjg input ")[
            i
          ].style.backgroundColor = "rgb(112, 182, 3)";
        }
      }, 50);
    },

    handleExport() {
      const { xmbh, jcnf, jccs } = this.queryParams;
      const data = {
        xmbh,
        jcnf,
        jccs,
      };
      exportfzInspecList(data).then((res) => {
        if (res.code === 0) {
          let fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          fileName = addExportFileDate(fileName);

          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    getPermision() {
      xmCheckAuthor({ xmbh: this.queryParams.xmbh }).then((res) => {
        if (res.code == 0) {
          if (res.data.manage == 1 || res.data.fz == 1) {
            this.canEdit = true;
          } else {
            this.canEdit = false;
          }
        }
      });
    },
    startWatching() {
      setInterval(() => {
        const currentStorage =
          JSON.parse(sessionStorage.getItem("fzCheckDetailParams")) || {};
        if (
          this.storageXmbh !== currentStorage.xmbh ||
          this.storagejccs != currentStorage.jccs
        ) {
          location.reload();
        }
      }, 1000);
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  margin-bottom: 15px;
}
.back {
  display: inline-block;
  background-color: #ffba01;
  height: 32px;
  width: 48px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
.xmmc {
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 700;
}
.footer-btn {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
</style>

